import React, { useState, useEffect } from "react";
import { Box, Card, CardContent } from "@material-ui/core";
import "../../styles/howitworks.scss";

const contentByPartner = {
  default: [
    {
      id: 1,
      title: "01.",
      icon: "/assets/images/step_1.png",
      heading: "Get a Guaranteed Backup Offer",
      content: [
        "Fill out a 3-minute questionnaire, and Calque will reach out within one business day to schedule a virtual home walk-through.",
        "If the property qualifies, Calque provides the homeowner with a Purchase Price Guarantee (PPG) within 1-9 business days, depending on the program.",
        "The loan officer originates a mortgage for the new home without a home sale contingency and adds a second lien on the departing home if equity unlock is needed.",
      ],
      note: "Note: The PPG acts as a backup offer. If your home doesn't sell within the specified timeframe (up to 150 days in most markets), Calque will buy it for the agreed price.",
    },
    {
      id: 2,
      title: "02.",
      icon: "/assets/images/step_2.png",
      heading: "Submit Competitive Offers",
      content: [
        "Begin submitting competitive offers with no home sale contingency.",
        "Calque's Purchase Price Guarantee provides the confidence of a guaranteed backup buyer.",
        "Complete the loan approval process and close on the new home.",
      ],
    },
    {
      id: 3,
      title: "03.",
      icon: "/assets/images/step_3.png",
      heading: "Win And Move Into New Home",
      content: [
        "Move with less stress, more convenience, and greater confidence.",
        "Repair and stage the original home to maximize its selling price.",
        "Show an home empty, avoiding the hassle of cleaning or leaving for showings.",
      ],
    },
    {
      id: 4,
      title: "04.",
      icon: "/assets/images/step_4.png",
      heading: "Sell Original Home With Peace Of Mind",
      content: [
        "Sell the original home!",
        "In the unlikely case the house does not sell on the open market within 150 days, Calque will buy it per the Purchase Price Guarantee (PPG).",
        "We've got your back. If Calque purchases the house, and we sell it for more than the PPG, Calque will refund the net profit after our expenses have been covered, including but not limited to the purchase price, commissions, interest, taxes, title and other fees.",
      ],
    },
  ],
};

function NewHowItWorks(props) {
  const urlPath = props?.partner?.url_path || "default";
  const sections = contentByPartner[urlPath] || contentByPartner.default;
  const [activeSection, setActiveSection] = useState(1);
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = screenSize <= 450;
  const isTablet = screenSize <= 850;

  return (
    <div className="how-it-works-main-container inter" id="trade">
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <h2 className="new-heading">
          <span
            style={{
              color: "#4594CB",
            }}
          >
            HOW IT WORKS
          </span>
          <br />4 Simple Steps
        </h2>
      </div>
      <Box
        className="how-it-works-container"
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        alignItems="center"
        justifyContent="center"
        gap={2}
      >
        {sections.map((section) => (
          <Card
            className="how-it-works-card"
            key={section.id}
            onMouseEnter={() => !isMobile && setActiveSection(section.id)}
            onMouseLeave={() => !isMobile && setActiveSection(null)}
            onClick={() =>
              isMobile &&
              setActiveSection(activeSection === section.id ? null : section.id)
            }
            style={{
              width: isMobile
                ? "90%"
                : activeSection === section.id
                ? "1000px"
                : activeSection === null
                ? "350px"
                : "250px",
              height: isMobile
                ? // ? activeSection === section.id
                  "auto"
                : isTablet
                ? "800px"
                : // : "100px"
                  "600px",
              backgroundColor:
                activeSection === section.id
                  ? "#fff"
                  : props?.partner?.primary_color,
              color: "#fff",
              transition: "all 0.3s ease-in-out",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background:
                  props?.partner?.secondary_color ||
                  "linear-gradient(358.33deg, rgba(27, 36, 51, 0.7) 1.39%, rgba(41, 46, 56, 0.909) 50%, rgba(43, 29, 29, 0.9) 98.61%)",
                opacity: activeSection === section.id ? 0.8 : 0,
                transition: "opacity 0.5s ease-in-out",
                zIndex: 0,
              }}
            />
            <CardContent
              className="new-how-it-works-card-content"
              style={{
                position: "relative",
                zIndex: 1,
                fontWeight: "600",
                justifyContent: "center",
              }}
            >
              <div
                className="new-card-number-heading"
                style={{ textAlign: "center" }}
              >
                <h2
                  className="new-card-number"
                  style={{
                    marginBottom:
                      activeSection === section.id ? "10px" : "30px",
                  }}
                >
                  {section.title}
                </h2>
              </div>
              <div
                style={{
                  textAlign: "center",
                  marginBottom: activeSection === section.id ? "10px" : "30px",
                }}
              >
                <img src={section.icon} alt="icon" />
              </div>
              <div className="how-content">
                <h4
                  className="new-card-heading"
                  style={{ textAlign: "center", marginBottom: "10px" }}
                >
                  {section.heading}
                </h4>
                {activeSection === section.id && (
                  <div className="new-card-list-content">
                    <ul
                      className="new-card-list"
                      style={{ padding: "0px 50px", marginBottom: "10px" }}
                    >
                      {section.content.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                    <p style={{ marginBottom: "10px", padding: "0px" }}>
                      <i>{section.note}</i>
                    </p>
                  </div>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </Box>
    </div>
  );
}

export default NewHowItWorks;
